import React from 'react';
import classNames from 'classnames';

import { CheckOutlined, CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Space } from 'antd';

import './steps.scss';

interface Step {
  label: string | React.ReactNode;
  status: 'process' | 'wait' | 'success' | 'error';
}

export interface StepsProps {
  activeKey: number;
  steps: Step[];
}

export const Steps: React.FC<StepsProps> = ({ steps, activeKey, children }) => {



  return (
    <div className="steps">
      <div className="steps--indicator">
        <Space size="middle" direction="horizontal">
          {steps.map((step, index) => {

            let label: string | React.ReactNode;

            switch(step.status) {
              case 'wait':
                label = <LoadingOutlined spin />
                break;

              case 'success':
                label = <CheckOutlined />
                break;

              case 'error':
                label = <CloseOutlined />
                break;

              case 'process':
              default:
                label = step.label;
                break;
            }


            return (
              <span key={index} className={classNames('step', {
                'active': index === activeKey,
                'loading': step.status === 'wait',
                'error': step.status === 'error',
                'success': step.status === 'success',
              })}>
                {label}
              </span>
            )
          })}
        </Space>
      </div>

      {children}
    </div>
  )
}
